




















































































































































































































import Vue from 'vue'
import SingleSlate from './SingleSlate'
import CasterPreview from './CasterPreview'
import Tweet from '@/components/Tweet'
import SimplecgElement from '@/components/SimplecgElement'
import InstagramElement from '@/components/InstagramElement'
import LiveChatElement from '@/components/LiveChatElement'
import { WidgetWrapper } from '@/components/Widgets'
import VideoPlayer from '@/components/VideoPlayer'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import { DynamicLayout } from '@/classes/DynamicLayout'
import { pickBy } from 'lodash'
import resize from 'vue-resize-directive'
import { minimumStingerDelay } from '.'
import './VideoPreviewDisplay.scss'
import { Cast } from '@/types/casts'
import { Stream, SourceStream, StreamDoc } from '@/types/streams'
import BotsMessages from '@/components/BotsMessages'
import clock from '@/classes/Clock'
import {
  TweetCSS,
  SimplecgCSS,
  InstagramCSS,
  LiveChatCSS,
  Layout,
  LayoutBoxType,
  ContentAlignment,
  LayoutBox,
  LayoutBoxField,
  TransitionType
} from '@/types/layouts'
import { Scene } from '@/types/scenes'
import { SceneContent } from '@/types/sceneContent'
import { AssetType, Asset } from '@/types/assets'
import { KeyDict } from '@/types'
import { cloneDeep } from 'lodash'
import Watermark from '@/components/WaterMark/Watermark.vue'

// if CEF mode we expect one of these resolutions
// (full dynamic sizing is possible with css transforms scaling+positioning)
const supported_resolutions = [
  { width: 1280, height: 720 },
  { width: 1920, height: 1080 },
]

interface SceneContentRendering extends SceneContent {
  volume?: number
  volumeLeft?: number
  volumeRight?: number
  leftrightsplit?: boolean
  slot?: string
  style: Partial<CSSStyleDeclaration>,
  stretchstyle: Partial<CSSStyleDeclaration>,
  asset?: Partial<Asset>,
  boxwidth?: number,
  boxheight?: number,
  tweetcss?: TweetCSS,
  simplecgcss?: KeyDict<SimplecgCSS>,
  instagramcss?: InstagramCSS,
  livechatcss?: LiveChatCSS,
  stretchVertical?: boolean,
  stretchContent?: 'true'|'',
  rawText?: string
}

////////////// Properties for scenes assets ////////////
const INSTANT_TRANSITION_ASSETTYPES = [AssetType.Stinger]
const GRAPHICS_TYPES = [AssetType.Graphic, AssetType.Stinger]
const LIVE_CHAT_TYPES = [AssetType.FacebookChat, AssetType.YouTubeChat]
const CALCULATE_VOLUME = [AssetType.Broadcast, AssetType.Caster, AssetType.Playlist]
const ALLOWED_LAYOUTBOX_FIELDS = {
  front: [LayoutBoxField.FRONT, LayoutBoxField.CASTER, LayoutBoxField.TRANSITION],
  back: [LayoutBoxField.BACK]
}
////////////////////////////////////////////////////////

export default Vue.extend({
  name: 'VideoPreviewDisplay',
  props: {
    scene: {
      type: Object as () => Scene|undefined,
      required: false
    },
    cast: {
      type: Object as () => Cast,
      required: false
    },
    sourceStreams: {
      type: Object as () => KeyDict<SourceStream>
    },
    streamsManager: {
      type: Object as () => KeyDict<Stream>
    },
    hideVideo: {
      type: Boolean,
      required: true
    },
    sceneInPreview: {
      type: String,
      required: false
    },
    cefActive: {
      type: Boolean,
      required: true,
      default: false
    },
    isIOS: {
      type: Boolean,
      required: false,
      default: false
    },
    cefMode: {
      type: String,
      required: false,
      default: ''
    },
    debugMode: {
      type: Boolean,
      required: false,
      default: false
    },
    streamDocs: {
      type: Object as () => KeyDict<StreamDoc>
    },
    streamNames: {
      type: Object as () => KeyDict<string>
    },
    streamImages: {
      type: Object as () => KeyDict<string>
    },
    activeTeam: {
      type: String
    },
    assets: {
      type: Object as () => KeyDict<Asset>,
      required: true
    },
    outputBroadcastAudio: {
      type: Boolean,
      default: true
    },
    sceneSwitchDelay: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      playlistVisible: false,
      // default setting for 16:9 ratio 1280x720, also support 1920x1080
      aspectWidth: supported_resolutions[0].width,
      aspectHeight: supported_resolutions[0].height,
      scaleFactor: 1, // maybe should be a computed property?
      videoAreaStyles: {} as Partial<CSSStyleDeclaration>,
      previousScene: this.scene,
      lastSceneSwitchTimestamp: 0,
      currentTimestamp: clock.nowInMilliseconds(),
      stingerPlaybackDelay: {} as KeyDict<number>,
      currentStingerDelay: 0
    }
  },
  watch: {
    scene (_newValue: Scene, oldValue: Scene) {
      this.onSceneSwitch(oldValue)
    },
    cast: {
      handler () {
        this.rerender()
      },
      deep: true
    },
    sourceStreams: {
      handler () {
        this.rerender()
      },
      deep: true
    }
    // TODO: Add prop and a watcher for the VolumeInterpolation speed?
  },
  mounted () {
    if (this.cefActive) {
      this.setDefaultAspectSize()
    }
  },
  computed: {
    allContents (): KeyDict<SceneContent> {
      // to make sure its reactive, couldnt find a better way
      if (this.currentTimestamp < 0) return {}
      const contents: KeyDict<SceneContent> = {}
      let scenes = { ...this.cast.scenes }
      if (this.inPreviewMode) scenes = {...scenes, ...this.cast.preview_scenes}
      Object.values(scenes).forEach(scene => {
        if (scene.contents) {
          for (const [contentId, content] of Object.entries(scene.contents)) {
            contents[contentId] = content
          }
        }
      })
      return contents
    },
    allRenderableContents (): KeyDict<SceneContentRendering> {
      const content: KeyDict<SceneContentRendering> = {}
      Object.keys(this.allContents).forEach(contentId => {
        const renderableContent = this.getSceneContent(contentId)
        if (renderableContent) content[contentId] = renderableContent
      })
      return content
    },
    broadcastFeeds () : KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes([AssetType.Broadcast])
    },
    graphics (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes(GRAPHICS_TYPES)
    },
    widgets (): KeyDict<SceneContentRendering> {
      const currentwidgets = this.getRenderingContentOfTypes([AssetType.Widget])
      if (this.cefActive && this.cefMode === 'back') return currentwidgets
      for (const [id, content] of Object.entries(this.integrations)) {
        currentwidgets[id] = content
      }
      return currentwidgets
    },
    tweets (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes([AssetType.Tweet, AssetType.TweetPoll])
    },
    simplecgElements (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes([AssetType.SimpleCG])
    },
    instagramPosts (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes([AssetType.Instagram])
    },
    liveChatMessages (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes(LIVE_CHAT_TYPES)
    },
    casters (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes([AssetType.Caster])
    },
    playlists (): KeyDict<SceneContentRendering> {
      return this.getRenderingContentOfTypes([AssetType.Playlist])
    },
    transitionDelay (): number {
      const asset = this.getActiveStingerAsset()
      return (asset && asset.transitionDelay) ? asset.transitionDelay + this.currentStingerDelay : 0
    },
    scenesWithFlattenedBoxes (): KeyDict<Scene> {
      const scenes: KeyDict<Scene> = {}
      for (const [id, scene] of Object.entries(this.cast.scenes)) {
        scenes[id] = this.unPackBoxes(scene)
      }
      return scenes
    },
    currentLayout (): Layout {
      // This is added because stretch info is distributed wrongly. This computed is depricated. Needs to go in the
      // global function to compute everything, but needed a quickfix now for NGE.
      if (this.currentTimestamp < (this.lastSceneSwitchTimestamp + this.transitionDelay)) return this.previousLayout
      return this.layout
    },
    layout (): Layout {
      if (!this.scene || !this.scene.scene_layout) {
        return { boxes: {} } as Layout
      }
      const currentLayout: Layout = cloneDeep(this.scene.scene_layout)
      Object.values(currentLayout.boxes).forEach(box => {
        if (box.type === LayoutBoxType.CONTAINER) {
          const dynamicLayout = new DynamicLayout(this.scene, box)
          if (box.boxes) {
            Object.values(box.boxes).forEach(subbox => {
              currentLayout.boxes[subbox.id] = { ...subbox }
              currentLayout.boxes[subbox.id].left = dynamicLayout.getLeft(subbox)
              currentLayout.boxes[subbox.id].top = dynamicLayout.getTop(subbox)
              currentLayout.boxes[subbox.id].field = box.field
            })
          }
        }
      })
      return currentLayout
    },
    previousLayout (): Layout {
      if (!this.previousScene || !this.previousScene.scene_layout) {
        return { boxes: {} } as Layout
      }
      const currentLayout: Layout = cloneDeep(this.previousScene.scene_layout)
      Object.values(currentLayout.boxes).forEach(box => {
        if (box.type === LayoutBoxType.CONTAINER) {
          const dynamicLayout = new DynamicLayout(this.previousScene, box)
          if (box.boxes) {
            Object.values(box.boxes).forEach(subbox => {
              currentLayout.boxes[subbox.id] = { ...subbox }
              currentLayout.boxes[subbox.id].left = dynamicLayout.getLeft(subbox)
              currentLayout.boxes[subbox.id].top = dynamicLayout.getTop(subbox)
              currentLayout.boxes[subbox.id].field = box.field
            })
          }
        }
      })
      return currentLayout
    },
    showPreviewVideo (): boolean {
      return !!(
        this.showLocalVideo === false &&
        this.previewOutput &&
        !this.inPreviewMode &&
        this.getPreviewStream !== null
      )
    },
    showLocalVideo (): boolean {
      return this.cefActive === true
    },
    getPreviewStream (): Stream | null {
      return this.streamsManager.hasOwnProperty('rtsppreview') ? this.streamsManager.rtsppreview : null
    },
    previewOutput (): Stream | null {
      const ret = this.streamsManager.hasOwnProperty('rtsppreview') ? this.streamsManager.rtsppreview : null
      if (ret && !ret.hasOwnProperty('id')) {
        ret.id = 'rtsppreview'
      }
      return ret
    },
    playlistbox (): string {
      const box = Object.values(this.currentLayout.boxes).find(box => {
        return box.types?.includes(AssetType.Video) ?? false
      })
      if (box !== undefined) return box.id
      return ''
    },
    leftBroadcastFeeds (): SceneContentRendering[] {
      return this.showLocalVideo === true || this.inPreviewMode ? Object.values(this.broadcastFeeds) : []
    },
    rightBroadcastFeeds (): SceneContentRendering[] {
      if (!this.cefActive) return []
      return Object.values(this.broadcastFeeds).filter(feed => feed.leftrightsplit === true)
    },
    inPreviewMode (): boolean {
      if (!this.scene) return false
      return this.sceneInPreview === this.scene.id
    },
    previewStreamLoaded (): boolean {
      return this.previewOutput !== null && this.previewOutput.hasOwnProperty('srcObject')
    },
    integrations (): KeyDict<SceneContentRendering> {
      const currentwidgets: KeyDict<SceneContentRendering> = {}
      if (this.cast.widgets) {
        for (const [widgetid, widget] of Object.entries(this.cast.widgets)) {
          if (this.scene?.scene_layout === undefined) continue
          const scene = this.getSceneForType(AssetType.Widget)
          if (scene === undefined) continue
          const box = Object.values(scene.scene_layout.boxes).find(box => box.types ? box.types.includes(widget.type) : false)
          const boxid = box ? box.id : 'none'
          const content: SceneContentRendering = {
            id: widget.id,
            active: widget.active !== undefined ? widget.active : false,
            type: (widget.type as unknown) as AssetType,
            box: boxid,
            idx: 0,
            name: '',
            order: 0,
            style: {},
            stretchstyle: {}
          }
          this.updateContentStyle(content, scene)
          currentwidgets[widgetid] = content
        }
      }
      return currentwidgets
    },
    cefMixer (): string {
      return this.$store.direct.state.events.cefMixer
    },
    widgetDelay (): number {
      if (this.cefActive) return 0
      return this.sceneSwitchDelay
    }
  },
  methods: {
    getSceneForType (type: AssetType): Scene|undefined {
      const delay = INSTANT_TRANSITION_ASSETTYPES.includes(type) ? 0 : this.transitionDelay
      if (this.currentTimestamp < (this.lastSceneSwitchTimestamp + delay)) return this.previousScene
      return this.sceneInPreview ? this.cast.preview_scenes[this.sceneInPreview] : this.scene
    },
    getRenderingContentOfTypes (types: AssetType[]): KeyDict<SceneContentRendering> {
      return pickBy(this.allRenderableContents, content => types.includes(content.type))
    },
    getSceneContent (contentId: string): SceneContentRendering | undefined {
      let content: SceneContentRendering|undefined = { style: {}, stretchstyle:{}, ...cloneDeep(this.allContents[contentId]) }
      if (content === undefined) return undefined
      let scene = this.getSceneForType(content.type)
      if (scene === undefined) return undefined
      scene = this.unPackBoxes(scene)
      if (scene.contents === undefined) return undefined
      if (scene.contents[contentId] === undefined) {
        this.updateContentToInvisible(content)
      } else {
        // get the correct info for the correct scene

        content = { ...content, ...this.normalizeContent(scene.contents[contentId]) }
        if (content.type === AssetType.Playlist) this.updatePlaylistBox(content, scene)
        this.updateContentStyle(content, scene)
      }
      const correctMode = this.correctMode(content)
      if (!correctMode.shouldExists) return undefined
      if (correctMode.hide) this.updateContentToInvisible(content)
      this.updateContentWithVolumes(content)
      content.asset = this.getAsset(contentId)
      this.updateContentWithSocialMediaCSS(content, scene)
      return content
    },
    updateContentToInvisible (content: SceneContentRendering) {
      // content.box = 'none'
      content.style = { ...content.style, opacity: '0' }
      if (content.type !== AssetType.Graphic) content.style = { ...content.style, display: 'none' }
    },
    updateContentWithSocialMediaCSS (content: SceneContentRendering, scene: Scene) {
      content.tweetcss = scene.scene_layout.tweetcss
      content.instagramcss = scene.scene_layout.instagramcss
      content.livechatcss = scene.scene_layout.livechatcss
      content.simplecgcss = scene.scene_layout.simplecgcss
    },
    updateContentStyle (content: SceneContentRendering, scene: Scene) {
      const box = scene.scene_layout.boxes[content.box]
      if (box === undefined) {
        this.updateContentToInvisible(content)
        return
      }
      const opacity = content.active && !box.invisible ? '1' : '0'
      const style: Partial<CSSStyleDeclaration> = {
        width: `${ box.width / 19.2 }%`,
        height: `${ box.height / 10.8 }%`,
        left: `${ box.left / 19.2 }%`,
        top: `${ box.top / 10.8 }%`,
        zIndex: `${ box.zindex }`,
        opacity: opacity,
        position: 'absolute',
        transform: 'translate3D(0,0,0)' // enables hardware acceleration + fixes Chrome layer compositioning issues with scaled parent >1.5x
      }
      content.boxwidth = (box.width / 1920) * this.aspectWidth,
      content.boxheight = (box.height / 1080) * this.aspectHeight
      if (content.type !== 'caster') {
        style.overflow = 'hidden'
      }
      this.updateContentWithStretchInfo(content, box)
      content.style = style
      this.updateContentWithSceneTransitionSpeed(content)
    },
    updateContentWithSceneTransitionSpeed (content: SceneContentRendering) {
      // This has to be the duration for the scene we are moving to
      if (this.cast.activeScene === null) {
        console.error('VideoPreviewDisplay::updateContentWithSceneTransitionSpeed - this.cast.activeScene is null')
        return
      }
      const destinationLayout = this.scenesWithFlattenedBoxes[this.cast.activeScene].scene_layout
      let duration = 0
      if (typeof destinationLayout.transition === 'object') {
        if (destinationLayout.transition.type === TransitionType.TRANSLATE) {
          duration = destinationLayout.transition.duration ?? 0
        } else {
          duration = 0
        }
      } else {
        duration = parseFloat(destinationLayout.transition) * 1000 // legacy duration is in seconds, not ms
      }

      if (duration < 0) duration = 0
      content.style.transitionDuration = `${ duration }ms`
    },
    updateContentWithVolumes (content: SceneContentRendering) {
      if (!CALCULATE_VOLUME.includes(content.type)) return
      const sourceStream = this.sourceStreams[content.id]
      content.volumeLeft = 0
      content.volumeRight = 0
      content.volume = 0
      if (this.streamDocs[content.id] !== undefined) {
        content.leftrightsplit = this.streamDocs[content.id].leftrightsplit ?? false
      }
      const ngcvpStatus = sourceStream !== undefined && sourceStream.active && content.active && content.box !== 'none'
      if (ngcvpStatus) {
        if (sourceStream.volumeLeft !== undefined) {
          content.volumeLeft = this.dBFSToGain(sourceStream.volumeLeft)
        }
        if (sourceStream.volumeRight !== undefined) {
          content.volumeRight = this.dBFSToGain(sourceStream.volumeRight)
        }
        if (sourceStream.volume !== undefined) {
          const volume = this.dBFSToGain(sourceStream.volume)
          // seems like the video player is using volume and volumeRight if there a splitaudio
          content.volume = content.leftrightsplit ? content.volumeLeft : volume
          content.muted = content.leftrightsplit ? content.leftMuted : content.muted
        }
      }
      if (content.type === AssetType.Playlist) content.volume = 1
    },
    updateContentWithStretchInfo (content: SceneContentRendering, box: LayoutBox) {
      content.stretchVertical = box.stretchContent ? (!!box.stretchVertical) : false
      content.stretchContent = (!!box && !!box.stretchContent) ? 'true' : ''
      const vertical = box.stretchVertical
      const justifyContent = (!vertical) ? box.contentalign  : ''
      const alignItems = (vertical) ? box.contentalign : ''
      const styles = {
        JustifyContent: justifyContent || ContentAlignment.CENTER,
        AlignItems: alignItems || ContentAlignment.CENTER,
      } as Partial<CSSStyleDeclaration>
      content.stretchstyle = styles
    },
    getActiveStingerAsset (): Asset|undefined {
      if (!this.scene?.contents) return undefined
      const stinger = Object.values(this.scene.contents).find((content) => content.type === AssetType.Stinger)
      if (!stinger || !stinger.active) return undefined
      return Object.values(this.assets).find((asset) => asset.id === stinger.id)
    },
    updatePlaylistBox (content: SceneContentRendering, scene: Scene) {
      const box = Object.values(scene.scene_layout.boxes).find(box => box.types?.includes(AssetType.Video))
      if (box !== undefined) content.box = box.id
    },

    stretchContent (boxId: string): string {
      if (boxId === 'none') return ''
      const box = this.findBox(boxId)
      return (!!box && !!box.stretchContent) ? 'true' : ''
    },
    stretchContentAlign (boxId: string): string {
      if (boxId === 'none') {
        return ''
      }
      const box = this.findBox(boxId)
      if (box) {
        return box.stretchContent ? String(box.contentalign) : ''
      } else {
        return '';
      }
    },
    findBox (id: string): LayoutBox | undefined {
      return this.currentLayout.boxes[id]
    },
    updateWidgetScale (): void {
      if (this.$refs.animationengine) {
        const div = this.$refs.animationengine as HTMLDivElement | undefined
        if (div === undefined) return
        const widthRatio = div.clientWidth / this.aspectWidth
        const heightRatio = div.clientHeight / this.aspectHeight
        this.scaleFactor = Math.min(widthRatio, heightRatio)

        if (!this.cefActive) {
          this.updateVideoAreaStyles()
        }
      }
    },
    setDefaultAspectSize () {
      // only really needed for CEF mode
      // = this makes sure transform scale(1) and translate(0,0)
      // = no pixel offsets needed to calculate div positions
      const div = this.$refs.videopreviewdisplay as HTMLDivElement
      if (div) {
        const match = supported_resolutions.find(o => o.width === div.clientWidth)
        if (match) {
          // change base resolution to match real size
          // needed in cef mode to make sure scale = 1, translate = 0
          // and read pixel positions without adding translate() offsets
          this.aspectWidth = match.width
          this.aspectHeight = match.height
        }
      }
    },
    updateVideoAreaStyles () {
      const div = this.$refs.videopreviewdisplay as HTMLDivElement | undefined
      if (div) {
        const translateX = (div.clientWidth - this.aspectWidth) / 2
        const translateY = (div.clientHeight - this.aspectHeight) / 2
        this.videoAreaStyles = {
          height: this.aspectHeight + 'px',
          width: this.aspectWidth + 'px',
          transform: `translate(${translateX}px, ${translateY}px) scale(${this.scaleFactor})`
        }
      }
    },
    isVisible (obj: SceneContentRendering): boolean {
      if (obj.style.display === 'none') return false
      if (obj.style.opacity === '0') return false
      return true
    },
    getSceneForContent (obj: SceneContent): Scene|undefined {
      const delay = (obj.type === AssetType.Stinger) ? 0 : this.transitionDelay
      if (this.currentTimestamp < (this.lastSceneSwitchTimestamp + delay)) return this.previousScene
      return this.scene
    },
    contentStyle (boxId: string): Partial<CSSStyleDeclaration> {
      const box = this.findBox(boxId)

      // no cropping when aspect ratio is preserved
      if (!box || box.aspectRatio || !box.stretchContent) return {}

      const vertical = box.stretchVertical
      const justifyContent = (!vertical) ? box.contentalign  : ''
      const alignItems = (vertical) ? box.contentalign : ''
      const styles = {
        JustifyContent: justifyContent || ContentAlignment.CENTER,
        AlignItems: alignItems || ContentAlignment.CENTER,
      } as Partial<CSSStyleDeclaration>

      return styles
    },
    correctMode (content: SceneContentRendering): { shouldExists: boolean, hide: boolean } {
      const fields: LayoutBoxField[] = []
      Object.values(this.scenesWithFlattenedBoxes).forEach(scene => {
        if (scene.contents) {
          const localContent = scene.contents[content.id]
          if (localContent !== undefined && scene.scene_layout.boxes[localContent.box]) {
            const field = scene.scene_layout.boxes[localContent.box].field
            if (field !== undefined && !fields.includes(field)) fields.push(field)
          }
        }
      })
      const box = this.findBox(content.box)
      if (this.inPreviewMode) return { shouldExists: true, hide: false }
      if (content.type === AssetType.Playlist) fields.push(LayoutBoxField.BACK)
      const renderfield = this.cefMode !== '' ? this.cefMode : 'front'
      if (this.cefActive && this.cefMode === 'front') {
        const hide = content.type === AssetType.Graphic && box?.field !== LayoutBoxField.FRONT
        return { shouldExists: content.type !== AssetType.Graphic || fields.includes(LayoutBoxField.FRONT), hide }
      }
      const shouldExists = ALLOWED_LAYOUTBOX_FIELDS[renderfield].find(value => fields.includes(value)) !== undefined
      let hide = ALLOWED_LAYOUTBOX_FIELDS[renderfield].find(value => box?.field === value) === undefined
      hide = hide && !INSTANT_TRANSITION_ASSETTYPES.includes(content.type)
      return { shouldExists, hide }
    },
    getCefIdOfStream (paramVideo: SceneContentRendering, variant: string|null = null): string {
      let id = paramVideo.id
      if (Object.keys(this.sourceStreams).length > 0 && this.sourceStreams.hasOwnProperty(id)) {
        if (variant && paramVideo.leftrightsplit === true) {
          id += '_' + variant
        }
      }
      return id
    },
    getStream (paramVideo: SceneContentRendering): Stream | null {
      return this.streamsManager !== undefined && this.streamsManager.hasOwnProperty(paramVideo.id + '_lowrate')
        ? this.streamsManager[paramVideo.id + '_lowrate']
        : null
    },
    getCasterStream (paramVideo: SceneContentRendering): Stream | null {
      return this.streamsManager !== undefined && this.streamsManager.hasOwnProperty(paramVideo.id + '_lowrate')
        ? this.streamsManager[paramVideo.id + '_lowrate']
        : null
    },
    dBFSToGain (volume: number): number {
      // expects value between 0 and 100 and outputs a value between 0 and 1
      if (volume === 0) return 0
      const dbfs = this.formatNum(this.scale(volume, 0, 100, -48, 0))
      return Math.pow(10, dbfs / 20)
    },
    formatNum (num: number): number {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2))
    },
    scale (num: number, in_min: number, in_max: number, out_min: number, out_max: number): number {
      return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
    },
    getBroadcastClasses (video: SceneContentRendering): string {
      if (video.id === '')  return ''
      let baseClasses = 'ngcvp-sink cef-broadcast cef-back'
      if (video.stretchVertical) baseClasses += ' stretch-vertical'
      if (this.currentLayout.clips.automute === true) baseClasses += ' cef-clipmute'
      return baseClasses
    },
    getCasterName (casterId: string): string {
      return this.streamNames.hasOwnProperty(casterId) ? this.streamNames[casterId] : ''
    },
    getAsset (key: string): Partial<Asset> {
      const asset = this.assets && this.assets[key]
      if (!asset) return {}
      const copyasset = cloneDeep(asset)
      return copyasset
    },
    getCasterImage (casterId: string): string {
      if (this.streamImages) {
        return this.streamImages.hasOwnProperty(casterId) ? this.streamImages[casterId] : ''
      }
      return ''
    },
    executeActions (baseDelay: number = 0) {
      if (this.scene === undefined) return
      if (typeof this.scene.scene_layout.transition === 'string') return // FIXME: when $store is backwards compatible...
      // Only execute these actions when you are the cef front on mixer0 (main output)
      if (this.cefActive == false) return
      if (this.cefMode !== 'front') return
      if (this.cefMixer !== 'mixer0') return

      try {
        for (const action of this.scene.scene_layout.transition.actions) {
          if (!action.offsetDelay) action.offsetDelay = 0
          const delay = baseDelay + action.offsetDelay
          window.setTimeout(() => {
            this.$store.direct.dispatch.layouts.performTransitionAction(action)
          }, delay)
        }
      } catch (exception) {
        console.error('Error executing custom actions', exception)
      }
    },
    unPackBoxes (scene: Scene): Scene {
      if (scene === undefined) {
        // We know this happens sometimes, we need data to figure out why?
        this.dumpComponent('VideoPreviewDisplay::unPackBoxes')
      }
      const currentLayout: Layout|undefined = cloneDeep(scene.scene_layout)
      if (currentLayout !== undefined) {
        Object.values(currentLayout.boxes).forEach(box => {
          if (box.type === LayoutBoxType.CONTAINER) {
            const dynamicLayout = new DynamicLayout(this.scene, box)
            if (box.boxes) {
              Object.values(box.boxes).forEach(subbox => {
                currentLayout.boxes[subbox.id] = { ...subbox }
                currentLayout.boxes[subbox.id].left = dynamicLayout.getLeft(subbox)
                currentLayout.boxes[subbox.id].top = dynamicLayout.getTop(subbox)
                currentLayout.boxes[subbox.id].field = box.field
              })
            }
          }
        })
      }
      const newScene = cloneDeep(scene)
      newScene.scene_layout = currentLayout
      return newScene
    },
    onUpdatePlaybackDelay ({ delay, id }: { delay: number, id: string }): void {
      // cannot be higher then 500ms as we only check after 500ms (or as set in minimumStingerDelay)
      // -> then it means we are getting back old values
      this.stingerPlaybackDelay[id] = delay < minimumStingerDelay ? delay : minimumStingerDelay
    },
    rerender () {
      this.currentTimestamp = clock.nowInMilliseconds()
      this.$forceUpdate()
    },
    normalizeContent (content: SceneContent): SceneContent {
      content.leftMuted = content.leftMuted ?? false
      content.rightMuted = content.rightMuted ?? false
      content.muted = content.muted ?? false
      return content
    },
    onSceneSwitch (oldScene: Scene) {
      this.previousScene = oldScene
      this.lastSceneSwitchTimestamp = clock.nowInMilliseconds()
      this.currentTimestamp = clock.nowInMilliseconds()
      const asset = this.getActiveStingerAsset()
      if (asset !== undefined) {
        this.stingerPlaybackDelay[asset.id] = minimumStingerDelay
      }
      // Goal: get stinger in sync with scene switch
      // We dont know when the stinger exactly started, we assume withing 0 - 500ms of telling it to start
      // The actual start of the stinger depends on buffering, ...
      // The actual start of the stinger will be within x ms of the start of the switch
      // The stinger will then tell this component the delay between its frames and the requested start time
      // that is stored within stingerPlaybackDelay
      // We wait here 500ms to be sure we received a update from the slate component and we then have enough information
      // to set the correct scene switch timing: time of the scene switch start + time of stinger delay - 500ms
      window.setTimeout(() => {
        if (asset === undefined) return
        this.currentStingerDelay = this.stingerPlaybackDelay[asset.id] ?? minimumStingerDelay
        if (this.currentStingerDelay >= minimumStingerDelay && this.cefActive) {
          console.error(`Delay has not been set yet for asset id: ${ asset.id }`, { ...this.stingerPlaybackDelay })
        }
        this.executeActions(this.transitionDelay - minimumStingerDelay)
        // console.log('Add stinger delay of ', this.currentStingerDelay)
        window.setTimeout(() => {
          this.currentTimestamp = clock.nowInMilliseconds()
        }, this.transitionDelay + 16 - minimumStingerDelay)  // 1 frame later, to make sure we dont get race conditions
      }, minimumStingerDelay)
    },
    dumpComponent (message: string) {
      try {
        const component = { ...this }
        const properties = ['scene', 'cast', 'sceneSwitchDelay', 'transitionDelay', 'currentLayout', 'previousLayout', 'assets']
        // Maximum call stack exceeded when trying to log all of these below...
        // const properties = [
        //   'scene', 'cast', 'sceneSwitchDelay', 'assets', 'allContents', 'allRenderableContents', 'graphics', 'widgets',
        //   'tweets', 'casters', 'transitionDelay', 'scenesWithFlattenedBoxes', 'layout', 'currentLayout', 'previousLayout'
        // ]
        for (const property of properties) {
          component[property] = this[property]
        }
        this.$store.direct.dispatch.logs.dumpComponent({ message, component })
      } catch (error) {
        console.error('dumpComponent failed', error)
      }
    }
  },
  components: {
    VideoPlayer,
    CasterPreview,
    Tweet,
    SimplecgElement,
    InstagramElement,
    LiveChatElement,
    SingleSlate,
    ClipLoader,
    WidgetWrapper,
    Watermark,
    BotsMessages
  },
  directives: {
    resize
  }
})
